/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S12_NoteInputs */

const tr_mesafeli_s12_note = /** @type {(inputs: Mesafeli_S12_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu hizmet seviyeleri, ücretli aboneliklerde satın alma anından itibaren geçerlidir. Ücretsiz deneme dönemlerinde hizmet seviyeleri taahhüt edilmez.`)
};

const en_mesafeli_s12_note = /** @type {(inputs: Mesafeli_S12_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These service levels apply to paid subscriptions from the moment of purchase. No service levels are guaranteed during free trial periods.`)
};

const de_mesafeli_s12_note = /** @type {(inputs: Mesafeli_S12_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Servicelevel gelten bei kostenpflichtigen Abonnements ab dem Zeitpunkt des Kaufs. In kostenlosen Testzeiträumen werden keine Servicelevel zugesichert.`)
};

const ru_mesafeli_s12_note = /** @type {(inputs: Mesafeli_S12_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данные уровни обслуживания применяются к платным подпискам с момента покупки. В бесплатных пробных периодах уровни обслуживания не гарантируются.`)
};

/**
* | output |
* | --- |
* | "These service levels apply to paid subscriptions from the moment of purchase. No service levels are guaranteed during free trial periods." |
*
* @param {Mesafeli_S12_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s12_note = /** @type {((inputs?: Mesafeli_S12_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S12_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s12_note(inputs)
	if (locale === "de") return de_mesafeli_s12_note(inputs)
	if (locale === "ru") return ru_mesafeli_s12_note(inputs)
	return tr_mesafeli_s12_note(inputs)
});